import React, {Fragment} from "react";
import BasicModal from "../../../../common/BasicModal";
import DixaSetupForm from "./DixaSetupForm";
import {basicModalStyle} from "../../Utilities/basicModalStyles";

export default function DixaSetupModal({open, handleClose, handleOpen}){

    return(
        <Fragment>
            <BasicModal
                open={open}
                handleClose={handleClose}
                handleOpen={handleOpen}
                title={'Connect with Dixa'}
                style={basicModalStyle}
            >
                <DixaSetupForm
                    description={'Paste your Dixa API Token here:'}
                    buttonLabel={'Submit'}
                    openInNewTab={true}
                    handleClose={handleClose}
                    extraInfoLabel={'View setup instructions'}
                />
            </BasicModal>
        </Fragment>
    )
}